export default __webpack_public_path__ + "static/media/m3_element_purple.b31f5193.png";